import * as React from "react";
import { Overlay, SideModal, SideModalContent } from "~/common/layout/Modals";
import Head from "~/common/layout/Head";
import ProductForm, { ProductInitialValues } from "../../components/products/ProductForm";
import { FC, useMemo, useState } from "react";
import { createOrgLocationsHelper } from "~/apps/shared/services/forms";
import { createProductSegmentHelper } from "~/apps/pos/shared/services/forms";
import { ProductSegmentType } from "~/apps/pos/consts";
import { FormikValues } from "formik";
import { connect } from "react-redux";
import { Features, UserRole } from "~/apps/shared/consts";
import { User } from "~/apps/shared/models";

type PropsFromRedux = {
  currentUser: User;
  features: string[];
};

type Props = PropsFromRedux & {
  initialValues: ProductInitialValues;
  title: string;
  error: string;
  isLoading: boolean;
  onSubmit: (data: FormikValues) => void;
  onClose: () => void;
};

const ProductFormOverlay: FC<Props> = ({
  title,
  initialValues,
  currentUser,
  currentUser: { organizationId },
  features,
  error,
  isLoading,
  onSubmit,
  onClose,
}) => {
  const isCategoryEnabled = features?.includes(Features.TRANSACTION_DATA_EXPOSED);
  const isAgent = currentUser.role === UserRole.AGENT;

  const [, forceUpdate] = useState({});

  const locationHelper = useMemo(
    () =>
      createOrgLocationsHelper(() => forceUpdate({}), organizationId, {
        label: "- Without Location -",
        value: "",
      }),
    []
  );

  const productCategoriesHelper = useMemo(
    () =>
      createProductSegmentHelper({
        refreshFn: () => forceUpdate({}),
        segmentType: ProductSegmentType.CATEGORY,
      }),
    []
  );

  const productGroupsHelper = useMemo(() => createProductSegmentHelper({ refreshFn: () => forceUpdate({}) }), []);

  return (
    <Overlay onClick={onClose} isLoading={isLoading}>
      <SideModal>
        <Head headTitle={title} />
        <SideModalContent>
          <ProductForm
            initialValues={initialValues}
            error={error}
            locationHelper={locationHelper}
            productCategoriesHelper={productCategoriesHelper}
            productGroupsHelper={productGroupsHelper}
            isCategoryEnabled={isCategoryEnabled}
            isAgent={isAgent}
            onSubmit={onSubmit}
            onClose={onClose}
          />
        </SideModalContent>
      </SideModal>
    </Overlay>
  );
};

const mapStateToProps = (state) => {
  return {
    currentUser: state.shared.auth.currentUser,
    features: state.shared.information.entities.features,
  };
};

export default connect(mapStateToProps)(ProductFormOverlay);
